import { Injectable } from '@angular/core';

import { RouterReducerState } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './person-profile.actions';
import * as personProfileQuery from './person-profile.selectors';

@Injectable()
export class PersonProfileFacade {
  personProfileId$ = this.store.pipe(select(personProfileQuery.getPersonId));

  personProfileSkeletonLoading$ = this.store.pipe(
    select(personProfileQuery.getPersonProfileSkeletonLoading)
  );
  personProfileSkeletonLoaded = this.store.pipe(
    select(personProfileQuery.getPersonProfileSkeletonLoaded)
  );
  personProfileAuditSkeleton$ = this.store.pipe(
    select(personProfileQuery.getAircraftProfileAuditSkeleton)
  );

  personProfileAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getPersonProfileAuditLoading)
  );
  personProfileAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getPersonProfileAuditLoaded)
  );
  personProfileAudits$ = this.store.pipe(select(personProfileQuery.getPersonProfileAudits));

  attributeAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getPersonAttributeAuditLoading)
  );
  attributeAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getPersonAttributeAuditLoaded)
  );
  attributeAudits$ = this.store.pipe(select(personProfileQuery.getPersonAttributeAudits));

  businessPersonAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getBusinessPersonAuditLoading)
  );
  businessPersonAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getBusinessPersonAuditLoaded)
  );
  businessPersonAudits$ = this.store.pipe(select(personProfileQuery.getBusinessPersonAudits));

  addressAuditsLoading$ = this.store.pipe(select(personProfileQuery.getAddressAuditLoading));
  addressAuditsLoaded$ = this.store.pipe(select(personProfileQuery.getAddressAuditLoaded));
  addressAudits$ = this.store.pipe(select(personProfileQuery.getAddressAudits));

  phoneNumberAuditLoaded$ = this.store.pipe(select(personProfileQuery.getPhoneNumberAuditLoaded));
  phoneNumberAuditLoading$ = this.store.pipe(select(personProfileQuery.getPhoneNumberAuditLoading));
  phoneNumbersAudits$ = this.store.pipe(select(personProfileQuery.getPhoneNumberAudits));

  emailAddressAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getEmailAddressAuditLoading)
  );
  emailAddressAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getEmailAddressAuditLoaded)
  );
  emailAddressAudits$ = this.store.pipe(select(personProfileQuery.getEmailAddressAudits));

  emergencyContactAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getEmergencyContactAuditLoading)
  );
  emergencyContactAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getEmergencyContactAuditLoaded)
  );
  emergencyContactAudits$ = this.store.pipe(select(personProfileQuery.getEmergencyContactAudits));

  emergencyContactPhoneNumberAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getEmergencyContactPhoneNumberAuditLoading)
  );
  emergencyContactPhoneNumberAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getEmergencyContactPhoneNumberAuditLoaded)
  );
  emergencyContactPhoneNumberAudits$ = this.store.pipe(
    select(personProfileQuery.getEmergencyContactPhoneNumberAudits)
  );

  executiveAssociateAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociateAuditLoading)
  );
  executiveAssociateAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociateAuditLoaded)
  );
  executiveAssociateAudits$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociateAudits)
  );

  executiveAssociatePhoneNumberAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociatePhoneNumberAuditLoading)
  );
  executiveAssociatePhoneNumberAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociatePhoneNumberAuditLoaded)
  );
  executiveAssociatePhoneNumberAudits$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociatePhoneNumberAudits)
  );

  executiveAssociateEmailAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociateEmailAuditLoading)
  );
  executiveAssociateEmailAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociateEmailAuditLoaded)
  );
  executiveAssociateEmailAudits$ = this.store.pipe(
    select(personProfileQuery.getExecutiveAssociateEmailAudits)
  );

  personStaffGroupAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getPersonStaffGroupAuditLoading)
  );
  personStaffGroupAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getPersonStaffGroupAuditLoaded)
  );
  personStaffGroupAudits$ = this.store.pipe(select(personProfileQuery.getPersonStaffGroupAudits));

  preferenceCateringAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getPreferenceCateringAuditLoading)
  );
  preferenceCateringAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getPreferenceCateringAuditLoaded)
  );
  preferenceCateringAudits$ = this.store.pipe(
    select(personProfileQuery.getPreferenceCateringAudits)
  );

  preferenceGroundTransportationAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getPreferenceGroundTransportationAuditLoading)
  );
  preferenceGroundTransportationAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getPreferenceGroundTransportationAuditLoaded)
  );
  preferenceGroundTransportationAudits$ = this.store.pipe(
    select(personProfileQuery.getPreferenceGroundTransportationAudits)
  );

  preferenceHotelAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getPreferenceHotelAuditLoading)
  );
  preferenceHotelAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getPreferenceHotelAuditLoaded)
  );
  preferenceHotelAudits$ = this.store.pipe(select(personProfileQuery.getPreferenceHotelAudits));

  staffInfoAuditsLoading$ = this.store.pipe(select(personProfileQuery.getStaffInfoAuditLoading));
  staffInfoAuditsLoaded$ = this.store.pipe(select(personProfileQuery.getStaffInfoAuditLoaded));
  staffInfoAudits$ = this.store.pipe(select(personProfileQuery.getStaffInfoAudits));

  crewMemberTypeRatingTypesLoading$ = this.store.pipe(
    select(personProfileQuery.getCrewMemberTypeRatingTypesLoaded)
  );
  crewMemberTypeRatingTypesLoaded$ = this.store.pipe(
    select(personProfileQuery.getCrewMemberTypeRatingTypesLoading)
  );
  crewMemberTypeRatingTypes$ = this.store.pipe(
    select(personProfileQuery.getCrewMemberTypeRatingTypes)
  );

  crewMemberTypeRatingAuditsLoading$ = this.store.pipe(
    select(personProfileQuery.getCrewMemberTypeRatingAuditLoading)
  );
  crewMemberTypeRatingAuditsLoaded$ = this.store.pipe(
    select(personProfileQuery.getCrewMemberTypeRatingAuditLoaded)
  );
  crewMemberTypeRatingAudits$ = this.store.pipe(
    select(personProfileQuery.getCrewMemberTypeRatingAudits)
  );

  taxInfoAuditsLoading$ = this.store.pipe(select(personProfileQuery.getTaxInfoAuditLoading));
  taxInfoAuditsLoaded$ = this.store.pipe(select(personProfileQuery.getTaxInfoAuditLoaded));
  taxInfoAudits$ = this.store.pipe(select(personProfileQuery.getTaxInfoAudits));

  passengerAuditsLoading$ = this.store.pipe(select(personProfileQuery.getPassengerAuditLoading));
  passengerAuditsLoaded$ = this.store.pipe(select(personProfileQuery.getPassengerAuditLoaded));
  passengerAudits$ = this.store.pipe(select(personProfileQuery.getPassengerAudits));

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadPersonProfileAudit() {
    this.store.dispatch(actions.ResetPersonProfile());
    this.store.dispatch(actions.LoadPersonProfileAuditSkeleton());
  }

  loadPersonProfileAudits(personId: number) {
    this.store.dispatch(actions.LoadPersonProfileAudit({ personId }));
  }

  nextPersonProfileAuditPage(personId: number) {
    this.store.dispatch(actions.LoadNextPagePersonProfileAudit({ personId }));
  }

  loadPassengerAudits(passengerId: number) {
    this.store.dispatch(actions.LoadPassengerAudit({ passengerId }));
  }

  nextPassengerAuditPage(passengerId: number) {
    this.store.dispatch(actions.LoadNextPagePassengerAudit({ passengerId }));
  }

  loadPersonAttributeAudits(personAttributeId: number) {
    this.store.dispatch(actions.LoadPersonAttributeAudit({ personAttributeId }));
  }

  nextPersonAttributeAuditPage(personAttributeId: number) {
    this.store.dispatch(actions.LoadNextPagePersonAttributeAudit({ personAttributeId }));
  }

  loadBusinessPersonAudits(businessPersonId: number) {
    this.store.dispatch(actions.LoadBusinessPersonAudit({ businessPersonId }));
  }

  nextBusinessPersonAuditPage(businessPersonId: number) {
    this.store.dispatch(actions.LoadNextPageBusinessPersonAudit({ businessPersonId }));
  }

  loadAddressAudits(addressId: number) {
    this.store.dispatch(actions.LoadAddressAudit({ addressId }));
  }

  nextAddressAuditPage(addressId: number) {
    this.store.dispatch(actions.LoadNextPageAddressAudit({ addressId }));
  }

  loadPhoneNumberAudits(phoneNumberId: number) {
    this.store.dispatch(actions.LoadPhoneNumberAudit({ phoneNumberId }));
  }

  nextPhoneNumberAuditPage(phoneNumberId: number) {
    this.store.dispatch(actions.LoadNextPagePhoneNumberAudit({ phoneNumberId }));
  }

  loadEmailAddressAudits(emailAddressId: number) {
    this.store.dispatch(actions.LoadEmailAddressAudit({ emailAddressId }));
  }

  nextEmailAddressAuditPage(emailAddressId: number) {
    this.store.dispatch(actions.LoadNextPageEmailAddressAudit({ emailAddressId }));
  }

  loadEmergencyContactAudits(emergencyContactId: number) {
    this.store.dispatch(actions.LoadEmergencyContactAudit({ emergencyContactId }));
  }

  nextEmergencyContactAuditPage(emergencyContactId: number) {
    this.store.dispatch(actions.LoadNextPageEmergencyContactAudit({ emergencyContactId }));
  }

  loadEmergencyContactPhoneNumberAudits(emergencyContactPhoneNumberId: number) {
    this.store.dispatch(
      actions.LoadEmergencyContactPhoneNumberAudit({ emergencyContactPhoneNumberId })
    );
  }

  nextEmergencyContactPhoneNumberAuditPage(emergencyContactPhoneNumberId: number) {
    this.store.dispatch(
      actions.LoadNextPageEmergencyContactPhoneNumberAudit({ emergencyContactPhoneNumberId })
    );
  }

  loadExecutiveAssociateAudits(executiveAssociateId: number) {
    this.store.dispatch(actions.LoadExecutiveAssociateAudit({ executiveAssociateId }));
  }

  nextExecutiveAssociateAuditPage(executiveAssociateId: number) {
    this.store.dispatch(actions.LoadNextPageExecutiveAssociateAudit({ executiveAssociateId }));
  }

  loadExecutiveAssociatePhoneNumberAudits(executiveAssociatePhoneNumberId: number) {
    this.store.dispatch(
      actions.LoadExecutiveAssociatePhoneNumberAudit({ executiveAssociatePhoneNumberId })
    );
  }

  nextExecutiveAssociatePhoneNumberAuditPage(executiveAssociatePhoneNumberId: number) {
    this.store.dispatch(
      actions.LoadNextPageExecutiveAssociatePhoneNumberAudit({ executiveAssociatePhoneNumberId })
    );
  }

  loadExecutiveAssociateEmailAudits(executiveAssociateEmailId: number) {
    this.store.dispatch(actions.LoadExecutiveAssociateEmailAudit({ executiveAssociateEmailId }));
  }

  nextExecutiveAssociateEmailAuditPage(executiveAssociateEmailId: number) {
    this.store.dispatch(
      actions.LoadNextPageExecutiveAssociateEmailAudit({ executiveAssociateEmailId })
    );
  }

  loadPersonStaffGroupAudits(personStaffGroupId: number) {
    this.store.dispatch(actions.LoadPersonStaffGroupAudit({ personStaffGroupId }));
  }

  nextPersonStaffGroupAuditPage(personStaffGroupId: number) {
    this.store.dispatch(actions.LoadNextPagePersonStaffGroupAudit({ personStaffGroupId }));
  }

  resetPreferenceCateringAudits() {
    this.store.dispatch(actions.ResetPreferenceCatering());
  }

  loadPreferenceCateringAudits(preferenceId: number) {
    this.store.dispatch(actions.LoadPreferenceCateringAudit({ preferenceId }));
  }

  nextPreferenceCateringAuditPage(preferenceId: number) {
    this.store.dispatch(actions.LoadNextPagePreferenceCateringAudit({ preferenceId }));
  }

  loadPreferenceGroundTransportationAudits(preferenceId: number) {
    this.store.dispatch(actions.LoadPreferenceGroundTransportationAudit({ preferenceId }));
  }

  nextPreferenceGroundTransportationAuditPage(preferenceId: number) {
    this.store.dispatch(actions.LoadNextPagePreferenceGroundTransportationAudit({ preferenceId }));
  }

  loadPreferenceHotelAudits(preferenceId: number) {
    this.store.dispatch(actions.LoadPreferenceHotelAudit({ preferenceId }));
  }

  nextPreferenceHotelAuditPage(preferenceId: number) {
    this.store.dispatch(actions.LoadNextPagePreferenceHotelAudit({ preferenceId }));
  }

  loadStaffInfoAudits(staffInfoId: number) {
    this.store.dispatch(actions.LoadStaffInfoAudit({ staffInfoId }));
  }

  nextStaffInfoAuditPage(staffInfoId: number) {
    this.store.dispatch(actions.LoadNextPageStaffInfoAudit({ staffInfoId }));
  }

  loadCrewMemberTypeRatingAudits(crewMemberTypeRatingId: number) {
    this.store.dispatch(actions.LoadCrewMemberTypeRatingAudit({ crewMemberTypeRatingId }));
  }

  nextCrewMemberTypeRatingAuditPage(crewMemberTypeRatingId: number) {
    this.store.dispatch(actions.LoadNextPageCrewMemberTypeRatingAudit({ crewMemberTypeRatingId }));
  }

  loadCrewMemberTypeRatingTypes() {
    this.store.dispatch(actions.LoadCrewMemberTypeRatingTypes());
  }

  loadTaxInfoAudits(taxInfoId: number) {
    this.store.dispatch(actions.LoadTaxInfoAudit({ taxInfoId }));
  }

  nextTaxInfoAuditPage(taxInfoId: number) {
    this.store.dispatch(actions.LoadNextPageTaxInfoAudit({ taxInfoId }));
  }
}
